import '../styles/upload_sales_popup.css';
import CloseIcon from '@mui/icons-material/Close';
import { steps } from '../UploadSales/UploadSalesPopup';

export const UploadPopup = (props) => {
    const { 
      step, 
      file, 
      onClosePopup, 
      uploadFileToValidate, 
      handleSubmitFile, 
      UploadResponse,
      downloadErrorFile,
      handleAcknowledge
    } = props;

    if(step === steps.confirm) {
        return (
          <>
            <div className="custom-popup-container-wrapper-body">
              <div className="tga-upload-text">Please ensure you only upload the Cannatrek Consignment Hub file. No other files will be accepted.</div>
              <div className="selected-tga-document-container">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src="/static/images/icon/document_upload-icon.svg" alt="document_upload-icon" style={{ height: "24.29px", marginRight: "16.74px" }} />
                  <div className="selected-tga-document-text">{file.name}</div>
                </div>
                <div><CloseIcon className="clear-selected-tga-document" onClick={() => onClosePopup()} /></div>
              </div>
            </div>
            <div className="custom-popup-container-wrapper-bottom">
              <div className="custom-popup-container-wrapper-bottom-right">
                <button className={`custom-popup-button-blue ${file.type.search("sheet") < 0?"disabled":""}`} onClick={uploadFileToValidate}
                  disabled={file.type.search("sheet") < 0}
                >Continue</button>
              </div>
            </div>
          </>
        );
      }
      else if(step === steps.loading) {
        return (
          <>
            <div className="custom-popup-container-wrapper-body">
              <div className="tga-upload-text">&nbsp;</div>
              <div className={`upload_tga-container`} style={{ position: "relative" }}>
                <input id="getFile1" style={{ opacity: "0", position: "absolute", top: "0", left: "0", right: "0", width: "100%", height: "100%", cursor: "pointer" }} />
                <img src="/static/images/icon/sales-upload-loading.svg" alt="loading-icon" style={{ height: "38px" }} />
                <div className="upload_tga-container-text">Loading</div>
              </div>
              <div className="popup-container-wrapper-body">
                <div className="upload-text-title">Uploading - Please Wait</div>
                <div className="upload-text-subtitle">Do not close your browser window whilst we review your upload file</div>
              </div>
            </div>
          </>
        );
      }
      else if(step === steps.uploading) {
        return (
          <>
            <div className="popup-container-wrapper-body">
              <img src="/static/images/icon/success_icon_blue.svg" alt="loading-icon" style={{ height: "38px" }} />
              <div className="upload-text-title">Upload Valid - Approved to Submit File</div>
              <div className="upload-text-subtitle">Your upload review is valid. To successfully upload your sales report, please select ‘submit file’ below.</div>
            </div>
            <div className="custom-popup-container-wrapper-bottom">
              <div className="custom-popup-container-wrapper-bottom-right">
                <div className="inline-group-button">
                  <button className={`custom-popup-button-cancel`} onClick={() => onClosePopup()}>Cancel</button>
                  <button className={`custom-popup-button-blue`} onClick={handleSubmitFile}>Submit File</button>
                </div>
              </div>
            </div>
          </>
        );
      }
      else if(step === steps.complete) {
        return (
          <>
            <div className="popup-container-wrapper-body">
              <img src="/static/images/icon/success_icon_dark_blue.svg" alt="loading-icon" style={{ height: "38px" }} />
              <div className="upload-text-title">File Uploaded</div>
              <div className="upload-text-subtitle">The upload process will run in the background</div>
              <div className="upload-text-subtitle">Process Complete; it is safe to close this window.</div>
            </div>
            <div className="custom-popup-container-wrapper-bottom">
              <div className="custom-popup-container-wrapper-bottom-right">
                <button className={`custom-popup-button-blue`} onClick={() => onClosePopup()}>Close</button>
              </div>
            </div>
          </>
        );
      }
      else if(step === steps.errorFirst) {
        return (
          <div className={`popup-container-error`}>
            <div className={`popup-container-wrapper-body-error`} key={`error-first`}>
              <div className={`title-container-error`}>
                <div className={`upload-text-title-error`}>DATA ERROR</div>
                <br/>
                <div className={`upload-text-title-error`}>Incorrect document type</div>
              </div>
              <div className={`upload-text-subtitle-error`}>It looks like you're attempting to upload a file that is not supported. The Cannatrek Consignment Hub requires all sales report uploads to be configured within the upload template. Please download the consignment report template and try again or contact your account manager for further support</div>
            </div>
            <button className={`custom-popup-button-error`} onClick={() => onClosePopup()}>Close</button>
          </div>
        );
      }
      else {
        const haveError = UploadResponse.some((data) => data.type === "error");
        const downloadErrorButton = (
          <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <button
              className={haveError ? `custom-popup-button-error` : 'custom-popup-button-warning-lite'}
              onClick={() => downloadErrorFile.mutate()}
              disabled={downloadErrorFile.isPending}
            >
              Download Error File
            </button>
          </div>
        );

        return ( 
          <div className={`popup-container-error`}>
            {UploadResponse.map((data, index) => {
              const isError = data.type === "error";
              return(
                <div className={`popup-container-wrapper-body-${isError ? 'error': 'warning'}`} key={`error-${index}`}>
                  <div className={`title-container-${isError ? 'error': 'warning'}`}>
                    <div className={`upload-text-title-${isError ? 'error': 'warning'}`}>{isError ? 'DATA ERROR': 'WARNING NOTICE'}</div>
                    <br/>
                    <div className={`upload-text-title-${isError ? 'error': 'warning'}`}>{data.title}</div>
                  </div>
                  <div className={`upload-text-subtitle-${isError ? 'error': 'warning'}`}>{data.message}</div>
                </div>
              );
            })}
            {haveError ?                            
                downloadErrorButton
            : 
              <div className="inline-group-button-center">
                {downloadErrorButton}
                <button className={`custom-popup-button-warning`} onClick={handleAcknowledge}>Acknowledge</button>
              </div>
            }
          </div>
        );
      }
}